@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.notificationdata
import com.narbase.letsgo.dto.core.KmmLong

data class DriverAcceptedDto(
    val status: String,
    val request_id: KmmLong,
    val name: String,
    val phone: String,
    val vehicle: String,
    val plate: String,
    val lat: Double,
    val lng: Double,
    val image: String
)